import { getBaseUrl } from './appSettings';

// API Configuration
export const apiConfig = {
  // API Endpoints
  endpoints: {
    // Authentication
    login: '/account/login',
    register: '/account/createuser',
    forgotPassword: '/Account/ForgotPassword',
    resetPassword: '/Account/ResetPassword',
    
    // Generic
    getCountries: '/Generic/GetCountries',
    getActiveSystemNotifications: '/Generic/GetActiveSystemNotifications',
    
    // User Management
    getUserProfile: '/User/GetUserProfile',
    updateUserProfile: '/User/UpdateProfile',
    
    // Dashboard
    getDashboardData: '/Dashboard/GetData',
    getDashboardWidgets: '/Dashboard/DashboardWidgets',
    getNextLotRebatePayment: '/Dashboard/GetNextLotRebatePayment',
    getDefaultAffiliatePromotion: '/Dashboard/GetDefaultAffiliatePromotion',
    getDefaultAffiliatePromotionAlt: '/AffiliatePromotions/GetDefaultAffiliatePromotion',
    getEarningOverview: '/Dashboard/EarningOverview',
    getPerformanceOverview: '/Dashboard/PerformanceOverview',
    getDashboardRangeSummary: '/Dashboard/DashboardRangeSummary',
    
    // Reports
    getReports: '/Reports/GetReports',
    getReportSummary: '/Reports/GetReportSummary',
    getReportRevenueMonthwise: '/Reports/GetReportRevenueMonthwise',
    getReportCommissionMonthwise: '/Reports/GetReportCommissionMonthwise',
    getReportSymbolBreakdown: '/Reports/GetReportSymbolBreakdown',
    getReportAffiliateList: '/Reports/GetReportAffiliateList',
    getReportClientsList: '/Reports/GetReportClientsList',
    getPerformanceWidgets: '/Reports/GetPerformanceWidgets',
    getMonthlyPerformanceTrend: '/Reports/GetMonthlyPerformanceTrend',
    getPerformanceSummary: '/Reports/GetPerformanceSummary',
    getAffiliateFunds: '/Transaction/GetAffiliateFunds',
    getTransactionWidget: '/Transaction/GetTransactionWidget',
    getWallets: '/Transaction/GetWallets',
    getSubPaymentMethods: '/Transaction/GetSubPaymentMethods',
    getPartnerPaymentDetails: '/Transaction/GetPartnerPaymentDetails',
    createPartnerPaymentDetails: '/Transaction/CreatePartnerPaymentDetails',
    updatePartnerPaymentDetails: '/Transaction/UpdatePartnerPaymentDetails',
    deletePartnerPaymentDetails: '/Transaction/DeletePartnerPaymentDetails',
    createWithdrawalRequest: '/Transaction/CreateWithdrawalRequest',
    
    // Commissions
    getCommissions: '/Commission/GetCommissions',
    getCommissionHistory: '/Commission/GetCommissionHistory',
    getOldDataHistory: '/Commission/GetOldDataHistory',
    getOldDataHistoryExportExcel: '/Commission/GetOldDataHistoryExportExcel',
    getCommissionWidgets: '/Commission/CommissionWidgets',
    getCommissionSummary: '/Commission/GetCommissionSummary',
    getEarningDashboard: '/Commission/GetEarningDashboard',

    // Clients
    getClientsList: '/Client/GetClientsList',
    getClientReport: '/Client/GetClientReport',
    downloadClientReportExcel: '/Client/DownloadClientReportExcel',
    
    // Affiliates
    getAffiliates: '/Affiliates/GetAffiliates',
    getSubPartnersList: '/Affiliate/GetSubPartnersList',
    getUserLevels: '/Affiliate/GetUserLevels',
    getAccountTierProgress: '/Affiliate/GetAccountTierProgress',
    getAffiliateTypes: '/Affiliate/GetAffiliateTypes',
    getPartnersLevels: '/Affiliate/GetPartnersLevels',
    sendSubPartnerInvite: '/Affiliate/SendSubPartnerInvite',
    getReferSubPartners: '/Affiliate/GetReferSubPartners',
    updateReferSubPartnerCommission: '/Affiliate/UpdateReferSubPartnerCommission',
    getAffiliateSubCommissions: '/Affiliate/GetAffiliateSubCommissions',
    createAffiliateSubCommission: '/Affiliate/CreateAffiliateSubCommission',
    updateAffiliateSubCommission: '/Affiliate/UpdateAffiliateSubCommission',
    deleteAffiliateSubCommission: '/Affiliate/DeleteAffiliateSubCommission',

    // Instruments Commission
    getInstrumentGroups: '/Instrument/GetInstrumentGroups',
    getInstrumentCommissions: '/Instrument/GetInstrumentCommissions',

    // Account Level
    getPointsCalculatorList: '/AccountLevel/GetPointsCalculatorList',
    
    // Withdrawal
    cancelWithdrawalRequest: '/Transaction/CancelWithdrawalRequest',
    
    // Fund Transfer
  createFundTransfer: '/Transaction/CreateFundTransfer',
  getInternalTransferList: '/Transaction/GetInternalTransferList',
  
  // Rewards
  getClaimRewardHistoryAll: '/Rewards/GetClaimRewardHistoryAll',
  getRewardList: '/Rewards/GetRewardList',
  getRewardTierList: '/Rewards/GetRewardTierList',
  getRewardTierPointsList: '/Rewards/GetRewardTierPointsList',
  getRewardsPointsSummary: '/Rewards/GetRewardsPointsSummary',
  getRewardsDashboard: '/Rewards/GetRewardsDashboard',
  getMilestoneProgress: '/Rewards/GetMilestoneProgress',
  getRewardsReport: '/Rewards/GetRewardsReport',
  getRewardCalculationList: '/Rewards/GetRewardCalculationList',
  claimReward: '/Rewards/ClaimReward',

  // Loyalty Points
  getLoyaltySummary: '/Loyalty/GetLoyaltySummary',
  getLoyaltyEventsList: '/Loyalty/GetLoyaltyEventsList',
  getLoyaltyEventPointsList: '/Loyalty/GetLoyaltyEventPointsList',
  getLoyaltyTiersList: '/Loyalty/GetLoyaltyTiersList',
  getLoyaltyTierDescriptionsList: '/Loyalty/GetLoyaltyTierDescriptionsList',
  getLoyaltyPointsHistory: '/Loyalty/GetLoyaltyPointsHistory',
  // legacy aliases (kept for older callers)
  getLoyaltyPointsSummary: '/Loyalty/GetLoyaltySummary',
  getLoyaltyDashboard: '/Loyalty/GetLoyaltySummary',
  getLoyaltyHistory: '/Loyalty/GetLoyaltyPointsHistory',
  getLoyaltyEarnRules: '/Loyalty/GetLoyaltyEventsList',

  // Affiliate Promotions
  getAffiliatePromotions: '/AffiliatePromotions/GetAffiliatePromotions',
  getMyAffiliatePromotions: '/AffiliatePromotions/GetMyAffiliatePromotions',
  claimAffiliatePromotion: '/AffiliatePromotions/ClaimAffiliatePromotion',

  // Challenges
  getChallengeOverview: '/Challenges/GetChallengeOverview',
  getChallengeParticipants: '/Challenges/GetChallengeParticipants',

  // Affiliate Notifications
  getAffiliateNotifications: '/AffiliateNotifications/GetNotifications',
  markAffiliateNotificationsRead: '/AffiliateNotifications/MarkAsRead',

  // Affiliate KYC / Documents (Client-compatible flow)
  getKycDocumentCategories: '/AffiliateDocuments/GetDocumentCategories',
  getKycDocumentTypes: '/AffiliateDocuments/GetDocumentTypes',
  uploadKycDocuments: '/AffiliateDocuments/UploadDocuments',
  getKycMyDocuments: '/AffiliateDocuments/GetMyDocuments',
  getKycStatus: '/AffiliateDocuments/GetAffiliateKYCStatus',
  getKycStatusAlias: '/AffiliateDocuments/GetKYCStatus',
  // legacy aliases (old wizard — kept for any leftover callers)
  getKycDetails: '/AffiliateDocuments/GetMyDocuments',
  saveKycPersonalDetails: '/Kyc/SavePersonalDetails',
  uploadKycIdentity: '/AffiliateDocuments/UploadDocuments',
  uploadKycAddress: '/AffiliateDocuments/UploadDocuments',
  submitKyc: '/AffiliateDocuments/GetAffiliateKYCStatus',
  
  // Affiliate Campaigns - Client
  createClientCampaign: '/AffiliateCampaigns/CreateClientCampaigns',
  getClientCampaignsList: '/AffiliateCampaigns/GetClientCampaignsList',
  deleteClientCampaign: '/AffiliateCampaigns/DeleteClientCampaign',
  updateClientCampaign: '/AffiliateCampaigns/UpdateClientCampaign',
  
  // Affiliate Campaigns - Sub Partner
  createSubCampaign: '/AffiliateCampaigns/CreateSubCampaign',
  getSubCampaignsList: '/AffiliateCampaigns/GetSubCampaignsList',
  deleteSubCampaign: '/AffiliateCampaigns/DeleteSubCampaign',
  updateSubCampaign: '/AffiliateCampaigns/UpdateSubCampaign',
  
  // Affiliate Campaigns - Dropdowns
  getClientCampaigns: '/AffiliateCampaigns/GetClientCampaigns',
  getSubCampaigns: '/AffiliateCampaigns/GetSubCampaigns',
  getBannerCategories: '/AffiliateCampaigns/GetBannerCategories',

  // Education — Courses
  getEducationCoursesList: '/Education/GetCoursesList',
  getEducationCourseById: '/Education/GetCourseById',
  createEducationCourse: '/Education/CreateCourse',
  updateEducationCourse: '/Education/UpdateCourse',
  activateEducationCourse: '/Education/ActivateCourse',
  inactivateEducationCourse: '/Education/InactivateCourse',
  deleteEducationCourse: '/Education/DeleteCourse',

  // Education — Modules
  getEducationModulesList: '/Education/GetModulesList',
  getEducationModuleById: '/Education/GetModuleById',
  createEducationModule: '/Education/CreateModule',
  updateEducationModule: '/Education/UpdateModule',
  activateEducationModule: '/Education/ActivateModule',
  inactivateEducationModule: '/Education/InactivateModule',
  deleteEducationModule: '/Education/DeleteModule',
  moveEducationModule: '/Education/MoveModule',

  // Education — Lessons
  getEducationLessonsList: '/Education/GetLessonsList',
  getEducationLessonById: '/Education/GetLessonById',
  createEducationLesson: '/Education/CreateLesson',
  updateEducationLesson: '/Education/UpdateLesson',
  activateEducationLesson: '/Education/ActivateLesson',
  inactivateEducationLesson: '/Education/InactivateLesson',
  deleteEducationLesson: '/Education/DeleteLesson',
  moveEducationLesson: '/Education/MoveLesson',
  getEducationLessonContent: '/Education/GetLessonContent',
  saveEducationLessonArticle: '/Education/SaveLessonArticle',
  uploadEducationLessonVideo: '/Education/UploadLessonVideo',
  uploadEducationLessonPdf: '/Education/UploadLessonPdf',
  deleteEducationLessonContent: '/Education/DeleteLessonContent',

  getEducationQuizSettings: '/Education/GetQuizSettings',
  saveEducationQuizSettings: '/Education/SaveQuizSettings',
  getEducationQuizQuestionsList: '/Education/GetQuizQuestionsList',
  getEducationQuizQuestionById: '/Education/GetQuizQuestionById',
  createEducationQuizQuestion: '/Education/CreateQuizQuestion',
  updateEducationQuizQuestion: '/Education/UpdateQuizQuestion',
  activateEducationQuizQuestion: '/Education/ActivateQuizQuestion',
  inactivateEducationQuizQuestion: '/Education/InactivateQuizQuestion',
  deleteEducationQuizQuestion: '/Education/DeleteQuizQuestion',
  moveEducationQuizQuestion: '/Education/MoveQuizQuestion',

  // Education — Analytics
  getEducationAnalyticsSummary: '/Education/GetAnalyticsSummary',
  getEducationCourseAnalytics: '/Education/GetCourseAnalytics',
  getEducationLearnerAnalytics: '/Education/GetLearnerAnalytics',
  getEducationQuizAnalytics: '/Education/GetQuizAnalytics',
  getEducationLearningActivity: '/Education/GetLearningActivity',
  getEducationPopularCourses: '/Education/GetPopularCourses',
  getEducationCompletionAnalytics: '/Education/GetCompletionAnalytics',
  },
  
  // Request Configuration
  requestConfig: {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    timeout: 30000 // 30 seconds
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${getBaseUrl()}${endpoint}`;
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    ...apiConfig.requestConfig.headers,
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

export default apiConfig;
